import React, { Fragment, useEffect, useRef, useState } from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import DragDrop from "../DragDrop/DragDrop";
import ApprovalsScreen from "./ApprovalsScreen";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import moment from "moment";
import { useGlobalState } from "../Context/GlobalStateContext";
export default function ReInvestmentsApproval() {
  const [showAnimation, setShowAnimation] = useState(false);
  const globalState = useGlobalState();
  const [programList, setProgramList] = useState<any>([]);
  const [quarterList, setQuarterList] = useState<any>([]);

  const [exceptionStatusList, setExceptionStatusList] = useState<any>([
    {
      PID: -1,
      Name: "All",
    },
    {
      PID: 0,
      Name: "In Progress",
    },
    {
      PID: 1,
      Name: "Approved",
    },
    {
      PID: 2,
      Name: "Rejected",
    },
  ]);

  const [exceptionDataFilter, setExceptionDataFilter] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    PFIDealerID: 0,
    IBBScorecardID: 0,
    PFIGroupIDs: "1",
    ReInvestmentStatusID: -1,
  });

  const [reinvestmentsData, setReInvestmentsData] = useState<any>([]);
  const [exceptionsDocuments, setExceptionsDocuments] = useState<any>([]);

  //MM:: Approval related data
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = exceptionDataFilter.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = exceptionDataFilter.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = exceptionDataFilter.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = exceptionDataFilter.ProgramID;

    let ReInvestmentStatusID = params.get("exsid") as any;
    if (ReInvestmentStatusID && ReInvestmentStatusID != "")
      ReInvestmentStatusID = Number(ReInvestmentStatusID);
    else ReInvestmentStatusID = exceptionDataFilter.ReInvestmentStatusID;

    setExceptionDataFilter((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
      ReInvestmentStatusID: ReInvestmentStatusID,
    }));

    IBBProgramGetProgramListForScorecard(IBBProgramID);
  }, []);

  useEffect(() => {
    if (exceptionDataFilter.ProgramID > 0 && exceptionDataFilter.QuarterID > 0)
      IBBReInvestmentGetDataForApproval();
  }, [exceptionDataFilter]);

  function IBBProgramGetProgramListForScorecard(IBBProgramID: number) {
    if (IBBProgramID == 0) IBBProgramID = exceptionDataFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = exceptionDataFilter.QuarterID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setExceptionDataFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }
          }

          setQuarterList(result[2]);
          if (exceptionDataFilter.QuarterID == 0) {
            let QuarterID = result[2][0].PID;
            setExceptionDataFilter((prevState: any) => ({
              ...prevState,
              QuarterID: QuarterID,
            }));
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBReInvestmentGetDataForApproval() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = exceptionDataFilter.ProgramID;
    object.quarterid = exceptionDataFilter.QuarterID;
    object.statusid = exceptionDataFilter.ReInvestmentStatusID;
    object.ibbprogramstageid = 21;
    object.ibbprogramsectionid = 0;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBReInvestment/IBBReInvestmentGetDataForApproval",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;

          if (result.length > 2) {
            let exceptionsDataLocal = [];
            var filtered = result[0];
            if (filtered.length > 0)
              exceptionsDataLocal.push({
                SectionTypeName: "Re-Investment Requests",
                Data: filtered,
              });

            setReInvestmentsData(exceptionsDataLocal);
            setExceptionsDocuments(result[1]);
            setRequiredApprovalUser(result[2]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function triggerApprovalParent() {
    IBBReInvestmentGetDataForApproval();
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Re-Investment Summary</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items">
              <select
                value={exceptionDataFilter.ProgramID}
                onChange={(e) => {
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(Number(e.target.value));
                }}
              >
                {programList &&
                  programList.map((item: any, index: any) => (
                    <option value={item.PID} key={"programoption" + item.PID}>
                      {item.Name}
                    </option>
                  ))}
              </select>

              <select
                value={exceptionDataFilter.QuarterID}
                onChange={(e) => {
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                }}
              >
                {quarterList &&
                  quarterList.map((item: any, index: any) => (
                    <option value={item.PID} key={"quarteroption" + item.PID}>
                      {item.Name}
                    </option>
                  ))}
              </select>

              <select
                value={exceptionDataFilter.ReInvestmentStatusID}
                onChange={(e) =>
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    ReInvestmentStatusID: Number(e.target.value),
                  }))
                }
              >
                {exceptionStatusList &&
                  exceptionStatusList.map((item: any, index: any) => (
                    <option
                      value={item.PID}
                      key={"exceptionStatusList" + item.PID}
                    >
                      {item.Name}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="section-table mb-10 exception-up">
            {reinvestmentsData &&
              reinvestmentsData.map((item: any, index: any) => (
                <React.Fragment key={item.SectionTypeName}>
                  <span className="buis-head font-16">
                    {item.SectionTypeName}
                  </span>
                  {item.Data &&
                    item.Data.map(
                      (itemReInvestment: any, indexException: any) => (
                        <React.Fragment
                          key={itemReInvestment.IBBReInvestmentID}
                        >
                          <div className="buis-case case-back plr-20">
                            <div className="excep-heading">
                              <span>{itemReInvestment.Title}</span>
                              <div className="flex-items">
                                <span>{itemReInvestment.RequestFor}</span>
                              </div>
                            </div>
                            <div className="exception-grid">
                              <div className="exceptions-left">
                                <div className="flex-items buis-head">
                                  <span>
                                    Amount:{" "}
                                    {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                      itemReInvestment.CurrencyID
                                    )}
                                    {itemReInvestment.RequestedAmountInUSD.toLocaleString(
                                      undefined,
                                      {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </span>{" "}
                                  <span>
                                    Date:{" "}
                                    {moment(item.RequestedTimestamp).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </span>
                                  {itemReInvestment.IBBPaymentCriteriaID !=
                                        3 && (
                                        <>
                                          <span>
                                            Function:{" "}
                                            {itemReInvestment.IBBDepartmentName}
                                          </span>{" "}
                                        </>
                                      )}
                                  <span>
                                    Payment Criteria:{" "}
                                    {itemReInvestment.IBBPaymentCriteriaName}
                                  </span>{" "}
                                  <span
                                    className={`
                               ${
                                 itemReInvestment.Status == 1 ? "sig-green" : ""
                               }
                               ${itemReInvestment.Status == 2 ? "sig-red" : ""}
                          `}
                                  >
                                    Status: {itemReInvestment.StatusName}
                                  </span>
                                </div>
                                <span>
                                  <b>Description:</b>
                                </span>
                                <span className="flex-items">
                                  {itemReInvestment.Description}
                                </span>
                                <div className="flex-items supp-doc">
                                  <span>Supporting Documents:</span>
                                  <>
                                    {exceptionsDocuments &&
                                      exceptionsDocuments.map(
                                        (
                                          ItemAttachment: any,
                                          indexAttachment: any
                                        ) => (
                                          <>
                                            {itemReInvestment.IBBReInvestmentID ==
                                              ItemAttachment.ObjectID && (
                                              <span
                                                key={
                                                  ItemAttachment.ObjectID +
                                                  "" +
                                                  indexAttachment
                                                }
                                              >
                                                <a
                                                  href={
                                                    ItemAttachment.FileURLRaw
                                                  }
                                                  target="blank"
                                                >
                                                  <img
                                                    src="images/pdf.svg"
                                                    width="40px"
                                                    height="40px"
                                                  />
                                                </a>
                                              </span>
                                            )}
                                          </>
                                        )
                                      )}
                                  </>
                                </div>
                              </div>
                              <div className="pg-importers appr-grid grid-signoff">
                                <div className="appr-main">
                                  <div className="exceptions-right">
                                    <div className="req-by">
                                      <div className="req-left">
                                        <span className="req-title show-block">
                                          Requested by
                                        </span>
                                        <span className="req-val">
                                          {itemReInvestment.RequestedByName}
                                        </span>
                                      </div>
                                      <div className="req-right"></div>
                                    </div>
                                    <div className="excp-approval">
                                      <ApprovalsScreen
                                        approvalObjectType={29}
                                        IBBProgramID={
                                          exceptionDataFilter.ProgramID
                                        }
                                        QuarterID={
                                          exceptionDataFilter.QuarterID
                                        }
                                        IBBProgramSectionID={0}
                                        ApprovalTextType={1}
                                        approvalObjectID={
                                          itemReInvestment.IBBReInvestmentID
                                        }
                                        uploadObjectType={
                                          AppContext.FileUploadObjectTypeExceptionApprovalFile
                                        }
                                        requiredApprovalUser={
                                          requiredApprovalUser
                                        }
                                        triggerApprovalParent={
                                          triggerApprovalParent
                                        }
                                      ></ApprovalsScreen>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )}
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
